import { HTMLElement } from 'node-html-parser'

export function matchElement(element: HTMLElement, re: RegExp): HTMLElement | undefined {
  const item = element.childNodes.find(
    (element) => element instanceof HTMLElement && re.test(element.textContent)
  )
  if (!item) {
    return undefined
  }

  const htmlItem = item as HTMLElement
  if (item.childNodes.length > 0) {
    return matchElement(htmlItem, re) || htmlItem
  }
  return htmlItem
}
